"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderCloseIcon = exports.HeaderTitle = exports.HeaderContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CloseLargeIcon = _interopRequireDefault(require("@8x8/oxygen-icon/icons/CloseLargeIcon"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _titleAlignment = _interopRequireDefault(require("../constants/titleAlignment"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HeaderContainer = _styledComponents["default"].div.attrs(function (_ref) {
  var testId = _ref.testId;
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)(testId));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  padding: ", ";\n  ", ";\n  box-shadow: ", ";\n  font-family: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.headerPadding;
}, function (_ref3) {
  var onClose = _ref3.onClose,
      theme = _ref3.theme;
  return onClose ? "padding-right: ".concat(theme.headerPaddingRightWithIcon) : '';
}, function (_ref4) {
  var hasBorderBottom = _ref4.hasBorderBottom,
      theme = _ref4.theme;
  return hasBorderBottom ? "".concat(theme.headerShadowSize, " ").concat(theme.headerShadowColor) : 'none';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.headerFontFamily;
});

exports.HeaderContainer = HeaderContainer;
HeaderContainer.propTypes = {
  hasBorderBottom: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  testId: _propTypes["default"].string.isRequired
};
HeaderContainer.defaultProps = {
  hasBorderBottom: false,
  onClose: undefined
};

var HeaderTitle = _styledComponents["default"].div.attrs(function () {
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)('MODAL_HEADER_TITLE'));
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  text-align: ", ";\n  ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.headerTitleFontSize;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.headerTitleLineHeight;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.headerTitleFontWeight;
}, function (_ref9) {
  var alignTitle = _ref9.alignTitle;
  return alignTitle;
}, (0, _polished.ellipsis)());

exports.HeaderTitle = HeaderTitle;
HeaderTitle.propTypes = {
  alignTitle: _propTypes["default"].oneOf(Object.values(_titleAlignment["default"]))
};
HeaderTitle.defaultProps = {
  alignTitle: _titleAlignment["default"].LEFT
};
var HeaderCloseIcon = (0, _styledComponents["default"])(_CloseLargeIcon["default"]).attrs(function () {
  return Object.assign({}, (0, _oxygenConfig.getTestAttributes)('MODAL_HEADER_CLOSE_ICON'));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.headerIconTop;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.headerIconRight;
});
exports.HeaderCloseIcon = HeaderCloseIcon;